/* pauseTeads handler */
import Container from '@components/atoms/container/adsContainer';
import Event from '@shared/classes/event';
import PauseAd from '@components/sections/pauseAd/pauseAd';
import TeadsUtils, { Placement } from '@shared/utils/teads';
import { adsSelector } from '@shared/store/slices/ads.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useEffect, useRef } from 'react';

export default function PauseTeadsHandler({ asset }: { asset?: Event }) {
  const { pauseAd } = useAppSelector(adsSelector);
  const inpausePlacement = useRef<any>(null);

  useEffect(() => {
    if (!window.teads?.SDK) return;
    const { sdkInstance, placementInstance } = TeadsUtils.initializeTeads({
      asset: asset,
      placementType: Placement.IN_PAUSE,
      placementId: 250081,
      containerId: 'pause-teads-container',
    });
    inpausePlacement.current = placementInstance;
    return () => {
      sdkInstance?.destroy?.();
    };
  }, []);

  useEffect(() => {
    if (pauseAd) {
      if (!inpausePlacement.current?.isAdReady) {
        inpausePlacement.current.loadAd();
      } else {
        inpausePlacement.current.playAd();
      }
    } else {
      inpausePlacement.current.stopAd();
    }
  }, [pauseAd]);

  return (
    <Container>
      <div
        style={{ width: '100%', height: '100%' }}
        id={'pause-teads-container'}
      />
      <PauseAd />
    </Container>
  );
}
